import { makeStyles } from "@material-ui/core/styles"

//padding order: top right bottom left

export default makeStyles((theme) => ({
  mainContainer: {
    margin: "0px",
    padding: "5px 0 0 5px",
  },
  subContainer: {
    margin: "0px",
    padding: "0px"
  }
}))
